export default "__VITE_ASSET__C_VjgU4l__"